import React, { useState, useRef, useEffect } from 'react';

const PostalCode = (props) => {
    const { placeholder, onChange, disabled, split, value, onFocus, onKeyUp, error, resetErrorMessage, loading } = props;
    const inputs = useRef(new Array(split.length));
    const [getValue, setValue] = useState(formatPostalCode(value));

    function replaceAll(src, search, replace) {
        return src?.split(search).join(replace);
    }

    useEffect(() => {
        if (inputs?.current[0]) {
            inputs.current[0].focus();
        }
    }, []);

    useEffect(() => {
        setValue(formatPostalCode(value));
    }, [value]);

    function formatPostalCode(value) {
        value = replaceAll(value.trim(), '-', '');
        const showValue = [];
        const splitFunc = (index, num) => {
            if (parseInt(index) < 0) return 0;
            if (parseInt(index) === 0) return num;
            return num + splitFunc(index - 1, split[index - 1]);
        };

        for (let index = 0; index < split.length; index++) {
            const slic = value.slice(
                splitFunc(index - 1, split[index - 1]),
                splitFunc(index, split[index]),
            );
            showValue.push(slic);
        }
        return showValue.join('-');
    }

    const handleChange = (e) => {
        if (resetErrorMessage)
            resetErrorMessage();
        e.stopPropagation();
        const { value } = e.target;
        const index = parseInt(e.target.name);
        const valueLength = getValue?.split('-').join('').length;
        const totalSplit = split.reduce((a, b) => a + b, 0);
        if (valueLength <= totalSplit) {
            const statevalue = getValue?.split('-');
            if (value.length <= split[index]) {
                if (!/^\s*\d*\s*$/.test(value)) {
                    e.preventDefault();
                } else if (value === "") {
                    statevalue[index] = value;
                }
                else {
                    statevalue[index] = value;
                }
            }
            const formatted = formatPostalCode(statevalue.join(''));
            setValue(formatted);
            onChange(formatted?.split('-').join(''));
            if (e.target.value !== '') {
                if (split[index] === formatted?.split('-')[index].length) {
                    if (index < split.length - 1) inputs.current[index + 1].focus();
                }
            }
        }
    };

    const handleOnKeydown = (event) => {
        const index = parseInt(event.target.name);
        const key = event.keyCode || event.charCode;
        if (key === 8 || key === 46) {
            if (index > 0) {
                setTimeout(() => {
                    inputs.current[index - 1].focus();
                });
            }
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (props.onKeyPress && typeof props.onKeyPress === 'function') {
                props.onKeyPress()
            } else {
                return;
            }
        }
    }

    const handlePaste = (event) => {
        event.stopPropagation();
        event.preventDefault();
        const index = event.target.name;
        const clipboardData = event.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        const statevalue = getValue?.split('-');
        for (const i in split) {
            let str = '';
            for (let y = 1; y <= split[i]; y++) {
                const res = pastedData.charAt(0);
                str = str.concat(res);
                pastedData = pastedData.substring(1);
            }
            statevalue[i] = str;
        }
        const formatted = formatPostalCode(statevalue.join(''));
        setValue(formatted);
        onChange(formatted?.split('-').join(''));
        inputs.current[split.length - 1].focus();
    };

    return (
        <div
            style={{
                gap: "8px",
                flexDirection: 'row-reverse'
            }}
            className={`d-flex justify-content-center gap-2 ${error ? 'input_error' : ''}`}>
            {split.map((item, index) => (
                <div
                    key={index}
                    style={{ width: '50px' }}
                    className={loading ? 'postal-code-box-spin' : ''}
                    data-spin-delay={index}
                >
                    <input
                        style={{
                            width: '50px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            height: '50px',
                            borderRadius: '10px',
                        }}
                        autoComplete="one-time-code"
                        onKeyPress={handleKeyPress}
                        className='form-control text-center'
                        type="tel"
                        name={index}
                        ref={(ref) => (inputs.current[index] = ref)}
                        placeholder='_'
                        value={getValue?.split('-')[index]}
                        onChange={handleChange}
                        onKeyDown={handleOnKeydown}
                        onPaste={handlePaste}
                        onFocus={index === 0 ? onFocus : undefined}
                        disabled={disabled}
                        onKeyUp={onKeyUp}
                    />
                </div>
            ))}
            <style>{`
                @keyframes postalCodeSpin {
                    0% {
                        transform: rotate(0deg) scale(1);
                    }
                    50% {
                        transform: rotate(360deg) scale(1.15);
                    }
                    100% {
                        transform: rotate(720deg) scale(1);
                    }
                }
                .postal-code-box-spin {
                    position: relative;
                    z-index: 5;
                    animation: postalCodeSpin 900ms ease-in-out infinite;
                }
                .postal-code-box-spin:nth-child(1) { animation-delay: 0ms; }
                .postal-code-box-spin:nth-child(2) { animation-delay: 80ms; }
                .postal-code-box-spin:nth-child(3) { animation-delay: 160ms; }
                .postal-code-box-spin:nth-child(4) { animation-delay: 240ms; }
                .postal-code-box-spin:nth-child(5) { animation-delay: 320ms; }
            `}</style>
        </div>
    );
};

PostalCode.defaultProps = {
    placeholder: '',
    value: '',
};

export default PostalCode;
